const RECENTLY_VIEWED_KEY = 'mtc_recently_viewed';

const RecentlyViewed = {
  get: () => {
    try {
      return JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY)) || [];
    } catch (e) {
      return [];
    }
  },
  track: (handle) => {
    if (!handle) return;
    try {
      const items = RecentlyViewed.get();
      const idx = items.indexOf(handle);
      if (idx > -1) items.splice(idx, 1);
      items.unshift(handle);
      localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(items.slice(0, 20)));
    } catch (e) {}
  },
};

function buildTrack(cardsHtml) {
  const track = document.createElement('div');
  track.className = 'mtc-carousel-track';
  track.innerHTML = cardsHtml;
  return track;
}

function updateArrowStates(section) {
  const activePanel = section.querySelector('.mtc-tab-panel:not([hidden])');
  const track = activePanel && activePanel.querySelector('.mtc-carousel-track');
  const prevBtn = section.querySelector('.mtc-carousel-btn--prev');
  const nextBtn = section.querySelector('.mtc-carousel-btn--next');
  if (!prevBtn || !nextBtn) return;

  if (!track || track.scrollWidth <= track.clientWidth) {
    prevBtn.disabled = true;
    nextBtn.disabled = false;
    return;
  }

  prevBtn.disabled = track.scrollLeft <= 1;
  nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
}

function attachTrackScrollListener(track) {
  track.addEventListener(
    'scroll',
    () => {
      const section = track.closest('.mtc-customer-carousels');
      if (section) updateArrowStates(section);
    },
    { passive: true }
  );
}

async function renderRecentlyViewed() {
  const container = document.getElementById('mtc-recently-viewed-container');
  if (!container) return;

  const max = parseInt(container.dataset.max) || 10;
  const emptyText =
    container.dataset.emptyText || 'Browse products to see your recently viewed items here.';
  const cardColorScheme = container.dataset.cardColorScheme || '';
  const handles = RecentlyViewed.get().slice(0, max);

  if (handles.length === 0) {
    showEmpty(container, emptyText);
    return;
  }

  try {
    const products = await window.MtcProductCard.fetchProducts(handles);

    if (products.length === 0) {
      showEmpty(container, emptyText);
      return;
    }

    const track = buildTrack(products.map((p) => window.MtcProductCard.buildCard(p, cardColorScheme)).join(''));
    container.textContent = '';
    container.appendChild(track);

    attachTrackScrollListener(track);

    const section = container.closest('.mtc-customer-carousels');
    if (section) updateArrowStates(section);
  } catch (err) {
    console.error('Recently viewed error:', err);
    showEmpty(container, emptyText);
  }
}

function showEmpty(container, text) {
  container.textContent = '';
  const p = document.createElement('p');
  p.className = 'mtc-customer-carousels__empty';
  p.textContent = text;
  container.appendChild(p);
}

function scrollCarousel(btn, dir) {
  const section = btn.closest('.mtc-customer-carousels');
  if (!section) return;
  const activePanel = section.querySelector('.mtc-tab-panel:not([hidden])');
  const track = activePanel && activePanel.querySelector('.mtc-carousel-track');
  if (!track) return;
  const card = track.querySelector('.wishlist-item');
  const cardWidth = card ? card.offsetWidth + 20 : 320;
  track.scrollBy({ left: dir * cardWidth * 2, behavior: 'smooth' });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mtc-customer-carousels').forEach((section) => {
    section.querySelectorAll('.mtc-carousel-track').forEach(attachTrackScrollListener);
    updateArrowStates(section);
  });

  renderRecentlyViewed();

  setTimeout(() => {
    document.querySelectorAll('.mtc-customer-carousels').forEach(updateArrowStates);
  }, 0);

  document.addEventListener('click', (e) => {
    if (e.target.closest('.mtc-carousel-btn--prev')) {
      scrollCarousel(e.target.closest('.mtc-carousel-btn--prev'), -1);
      return;
    }
    if (e.target.closest('.mtc-carousel-btn--next')) {
      scrollCarousel(e.target.closest('.mtc-carousel-btn--next'), 1);
      return;
    }

    const btn = e.target.closest('.mtc-tab-btn');
    if (!btn) return;

    const targetTab = btn.dataset.tab;
    const section = btn.closest('.mtc-customer-carousels');
    if (!section) return;

    section.querySelectorAll('.mtc-tab-btn').forEach((b) => {
      b.classList.toggle('mtc-tab-btn--active', b === btn);
      b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
    });

    section.querySelectorAll('.mtc-tab-panel').forEach((panel) => {
      panel.hidden = panel.id !== `mtc-tab-${targetTab}`;
    });

    updateArrowStates(section);
  });
});
